
/* injects from baggage-loader */

const indexOf = [].indexOf || function (item) {
    for (var i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

const moduleEditorNav = angular.module('editorNavigation.controller', ["api.widget", "services.layoutEditor.sectionDragDrop"]);

moduleEditorNav.controller("EditorNavigationCtrl", [
  "$scope", "$state", "$timeout", "layoutEditor", "insertSpace", "ns", "sectionDragDrop", "$injector", "Section", "editorNavSections", "Site", "FileUploader", "$cookies", "$rootScope", "editorDragPanel", "Restangular", "Modal", "Template", "$sce", "State", "Page", "TimeMachine", "blockEditDialog", "Notification", "Widget", "Email", "$filter", "$translate",
  ($scope, $state, $timeout, layoutEditor, insertSpace, ns, sectionDragDrop, $injector, Section, editorNavSections, Site, FileUploader, $cookies, $rootScope, editorDragPanel, Restangular, Modal, Template, $sce, State, Page, TimeMachine, blockEditDialog, Notification, Widget, Email, $filter, $translate) => {

    $scope.currentEditorTab = "";
    $scope.currentNavEditorTab = "";
    $scope.sectionsCollection = [];
    $scope.widthType = "px";
    $scope.editCurrentTab = "blockSettings";
    $scope.openTab = function (tab) {
      $scope.editCurrentTab = tab;
    };
    $scope.togglePagesSettings = function () {
      $scope.popoverOpen = !$scope.popoverOpen;
    };
    $scope.closePagesSettings = function () {
      $scope.popoverOpen = false;
    };
    $scope.closeEditorNav = function () {
      const $tools = $(".e__tools");

      if ($tools.scope().editorNavOpenWidget) {
        $rootScope.editSection();
      } else {
        $tools.scope().editorNavOpenWidget = false;
        $tools.scope().editorNavOpen = false;
        if (!$tools.scope().$$phase) {
          $tools.scope().$apply();
        }
      }
    };
    $scope.jcButtonColors = [
      {
        color: "#bf7404",
        classes: "g-button orange"
      }, {
        color: "#06bf47",
        classes: "g-button green"
      }, {
        color: "#014b81",
        classes: "g-button blue"
      }, {
        color: "#bd0209",
        classes: "g-button red"
      }, {
        color: "#630461",
        classes: "g-button pink"
      }
    ];
    $scope.setFrameButtonColor = function (color, data) {
      var c, i, len, ref;
      ref = $scope.jcButtonColors;
      for (i = 0, len = ref.length; i < len; i++) {
        c = ref[i];
        c.active = false;
      }
      data.frame_settings.frame_button_color = color.classes;
      color.active = true;
    };
    $scope.offertFieldEnabled = function (orderFields) {
      return _.filter(orderFields, {
        name: "offerta"
      })[0].exist;
    };
    $rootScope.$on("translations:loaded", function () {
      return $scope.add_ad_channels = function () {
        return $scope.ad_channels = [
          {
            name: "cpc",
            title: "" + ($filter('translate')('widget.form.utms.option1'))
          }, {
            name: "affiliate",
            title: "" + ($filter('translate')('widget.form.utms.option11'))
          }, {
            name: "cpl",
            title: "" + ($filter('translate')('widget.form.utms.option2'))
          }, {
            name: "cps",
            title: "" + ($filter('translate')('widget.form.utms.option3'))
          }, {
            name: "cpm",
            title: "" + ($filter('translate')('widget.form.utms.option4'))
          }, {
            name: "social",
            title: "" + ($filter('translate')('widget.form.utms.option5'))
          }, {
            name: "display",
            title: "" + ($filter('translate')('widget.form.utms.option6'))
          }, {
            name: "email",
            title: "" + ($filter('translate')('widget.form.utms.option7'))
          }, {
            name: "mobile",
            title: "" + ($filter('translate')('widget.form.utms.option8'))
          }, {
            name: "remarketing",
            title: "" + ($filter('translate')('widget.form.utms.option9'))
          }, {
            name: "other",
            title: "" + ($filter('translate')('widget.form.utms.option10'))
          }
        ];
      };
    });
    $scope.concatFonts = function () {
      if (Editor.Instrumentations.fonts) {
        return Editor.Instrumentations.fonts.concat(Editor.Instrumentations.defaultFonts);
      }
    };
    $scope.state = $state;
    const updatePreviews = function () {
      const d = new Date();
      $(".etn__preview-favicon__image").each(function () {
        const oldattr = $(this).attr("ng-src");
        if (oldattr) {
          $(this).attr("src", (oldattr + "?") + d.getTime());
        }
      });
      $(".etn__preview-image").each(function () {
        const oldattr = $(this).attr("ng-src");
        if (oldattr) {
          $(this).attr("src", (oldattr + "?") + d.getTime());
        }
      });
    };

    const applyStyleToTemplate = function (site) {
      return $rootScope.$broadcast("get:styles");
    };

    $scope.saveSite = function (site, siteSettingsForm) {
      if (siteSettingsForm.$invalid) {
        return false;
      }
      site = angular.copy(site);
      $scope.savingSite = true;
      return Site.update(site).then(function () {
        $scope.savingSite = false;
        applyStyleToTemplate(site);
      }, function () {
        return $scope.savingSite = false;
      });
    };

    const shakeAnimation = function () {
      $scope.shakeIt = true;
      $timeout(function () {
        $scope.shakeIt = false;
      }, 400);
    };

    $scope.help = function () {
      $rootScope.openVideoTutorial();
    };

    $rootScope.editorNavTab = function (tab, sectionsTag, sectionsTab) {
      if (sectionsTag == null) {
        sectionsTag = void 0;
      }
      if (sectionsTab == null) {
        sectionsTab = false;
      }
      $("#mini-sections").scrollTop(0);
      $scope.currentEditorTab = "";
      $scope.currentNavEditorTab = "";
      if (!$scope.$$phase) {
        $scope.$apply();
      }
      $rootScope.sectionDropTutorial = false;
      if (tab === 'sections') {
        $scope.currentNavEditorTab = 'sections';
        $rootScope.getPublicSections(sectionsTag);
        $rootScope.openEditorNavPanel();
        if (sectionsTab) {
          $rootScope.$broadcast("open:tab", "sections");
        }
        return false;
      }
      if (tab === 'blockSettings') {
        $scope.currentNavEditorTab = 'blockSettings';
        return false;
      }
      $scope.currentNavEditorTab = tab;
    };
    $scope.menuSlideLeft = function () {
      var ref, rightViews;
      rightViews = ['adminSettings', 'templateSettings', 'pagesSettings', 'fontSettings', 'blockSettings', 'faviconSettings', 'seoSettings', 'networkingSettings', 'domainSettings'];
      return ref = $scope.currentNavEditorTab, indexOf.call(rightViews, ref) >= 0;
    };

    const hideSubEditorTab = function (e) {
      if ($scope.currentEditorTab === 'mainSettings') {
        $rootScope.editorNavTab("templateSettings");
      }
    };

    $scope.subEditorTab = function (tab) {
      if ($scope.currentEditorTab === tab) {
        $scope.currentEditorTab = "";
      } else {
        $scope.currentEditorTab = tab;
      }
    };
    $scope.editorAccordion = function (e) {
      var thisElement, thisSection;
      thisElement = angular.element(e.target);
      thisSection = thisElement.siblings('.ms__section');
      if (thisElement.hasClass('ms__title_active')) {
        thisElement.removeClass('ms__title_active');
        thisSection.removeClass('ms__section_active');
        return;
      } else {
        thisElement.addClass('ms__title_active');
        thisSection.addClass('ms__section_active');
        return;
      }
      return returneditorTab;
    };
    $rootScope.$on("translations:loaded", function () {
      $scope.bgOptions = [
        {
          name: "none",
          name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size1')
        }, {
          name: "repeat",
          name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size2')
        }, {
          name: "cover",
          name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size3')
        },
        {
          name: "contain",
          name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size4')
        }
      ];
      $scope.contentEffects = [
        {
          name: "none",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.effect1")
        }, {
          name: "top",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.effect2")
        }, {
          name: "left",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.effect3")
        }, {
          name: "right",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.effect4")
        }, {
          name: "bottom",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.effect5")
        }, {
          name: "fade",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.effect6")
        }, {
          name: "zoom",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.effect7")
        }
      ];
      return $scope.getNameContentType = function (type) {
        switch (type) {
          case "none":
            return $scope.contentEffects[0].name_ru;
          case "top":
            return $scope.contentEffects[1].name_ru;
          case "left":
            return $scope.contentEffects[2].name_ru;
          case "right":
            return $scope.contentEffects[3].name_ru;
          case "bottom":
            return $scope.contentEffects[4].name_ru;
          case "fade":
            return $scope.contentEffects[5].name_ru;
          case "zoom":
            return $scope.contentEffects[6].name_ru;
        }
      };
    });
    $scope.setBgOption = function (name, section) {
      switch (name) {
        case "none":
          setSectionBgNoOption(section);
          break;
        case "repeat":
          setSectionBgRepeat(section);
          break;
        case "contain":
          setSectionBgContain(section);
          break;
        case "cover":
          setSectionBgCover(section);
      }
      $scope.saveSection(section);
    };
    $rootScope.$on("translations:loaded", function () {
      return $scope.bgEffects = [
        {
          name: "none",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect1")
        }, {
          name: "fixed",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect2")
        }, {
          name: "parallax",
          name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect3")
        }
      ];
    });
    $scope.refreshUploader = true;
    $scope.refreshUploaderFunc = function () {
      $scope.refreshUploader = false;
      $timeout(function () {
        $scope.refreshUploader = true;
      }, 100);
    };
    $scope.removeEmailBg = function (section, imageId) {
      Section.destoyItem(section, imageId).then(function () {
        section.background_attributes.images_attributes.splice(0, 1);
        $scope.refreshUploaderFunc();
      });
    };
    $scope.setBgEffect = function (name, section) {
      switch (name) {
        case "none":
          setSectionBgNoEffect(section);
          break;
        case "fixed":
          setSectionBgFixed(section);
          break;
        case "parallax":
          setSectionBgParallax(section);
      }
      $scope.saveSection(section);
    };
    $scope.newsPages = function () {
      if ($rootScope.site) {
        return _.filter($rootScope.site.pages, {
          type: "news"
        });
      }
    };
    $scope.getPageNameById = function (id) {
      var pages;
      pages = _.filter($rootScope.site.pages, {
        id: id
      });
      if (!id || pages.length === 0) {
        return "";
      }
      return pages[0].name;
    };

    const setSectionBgFixed = function (section) {
      section.style_attributes.backgroundAttachment = "fixed";
      section.background_attributes.parallax = false;
    };

    const setSectionBgParallax = function (section) {
      section.style_attributes.backgroundAttachment = "inherit";
      section.background_attributes.parallax = true;
    };

    const setSectionBgNoEffect = function (section) {
      section.background_attributes.parallax = false;
      section.style_attributes.backgroundAttachment = "inherit";
    };

    const setSectionBgRepeat = function (section) {
      section.style_attributes.backgroundRepeat = "repeat";
      section.style_attributes.backgroundSize = "initial";
    };

    const setSectionBgCover = function (section) {
      section.style_attributes.backgroundRepeat = "no-repeat";
      section.style_attributes.backgroundSize = "cover";
    };

    const setSectionBgContain = function (section) {
      section.style_attributes.backgroundRepeat = "no-repeat";
      section.style_attributes.backgroundSize = "contain";
    };

    const setSectionBgNoOption = function (section) {
      section.style_attributes.backgroundRepeat = "no-repeat";
      section.style_attributes.backgroundSize = "initial";
    };

    let timeoutId

    const saveSection = function (section) {
      if (timeoutId) {
        clearInterval(timeoutId)
      }

      timeoutId = setTimeout(() => {
        const newsection = angular.copy(blockEditDialog.currentBlock.section);
        const oldSection = angular.copy(blockEditDialog.currentBlock.old_section);

        layoutEditor.updateSectionEtag(newsection);

        newsection.colors = _.map(newsection.colors, function (tag, index) {
          return tag.text;
        });
        newsection.tags = _.map(newsection.tags, function (tag, index) {
          return tag.text;
        });
        newsection.tags = newsection.tags.join(",");

        if (Editor.mode === "editor.section") {
          Section.saveSettings(newsection).then(function (sectionData) {
            section.background_attributes.images_attributes = sectionData.background_attributes.images_attributes;
          });
        }
      }, 100)
    };

    $scope.saveSectionWithoutTimeout = function (section) {
      saveSection(section);
    };

    $scope.saveSection = function (section) {
      $timeout(function () {
        saveSection(section);
      });
    };

    const protocolPresent = function (str) {
      // если задана переменная вида {$activationLink}, то при её замене подставится и протокол
      if (str.match(/^{\$.*}$/)) {
        return true;
      }

      let pattern;

      pattern = new RegExp(/^(?:https?|ftp):\/\//);
      if (pattern.test(str)) {
        return true;
      }

      pattern = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9\+.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[.\!\/\\w]*))?)/);
      return pattern.test(str);
    };

    let previusValidateLink = '';

    $rootScope.enableNextPageOption = window.justclick && !!window.justclick.useNextPageUrl;
    $rootScope.validateLink = function (model, key) {
      if (model.link_href_target === "next") {
        model[key] = '#nextPage';
      } else if (model[key] === '#nextPage') {
        model[key] = previusValidateLink;
      }

      const linkIsNotProtocol = !(model[key] === 'http://' || model[key] === 'https://');
      const linkHaveNotProtocol = !protocolPresent(model[key]);

      if (linkHaveNotProtocol && linkIsNotProtocol && (model.link_href_target === "blank" || !model.link_href_target)) {
        model[key] = "https://" + (model[key] || '');
        previusValidateLink = model[key];
      }

      if (model.link_href_target === "none") {
        model[key] = model[key].replace("https://", "");
        model[key] = model[key].replace("http://", "");
        previusValidateLink = model[key];
      }
    };

    $rootScope.validateNumber = function(model, key) {
      if (typeof model[key] !== "number") {
        model[key] = 0;
      }
    }

    $scope.addImageToLibrary = function (image) {
      image = {
        tag: image.tag,
        image_attributes: {
          remote_source_url: image.image_attributes.source_url
        }
      };
      $scope.addingToLibrary = true;
      Widget.createImage(image).then(function () {
        Notification.success({
          message: 'Картинка добавлена в библиотеку'
        });
        $scope.addingToLibrary = false;
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/editor_nav/editorNav.controller.js